import FEGORender from '@futuweb/fego-render';

import { useFego } from './useFego';
export const useRateMethod = () => {
    const getRateClass = (rate) => {
        rate = parseFloat(rate);
        if (rate > 0) {
            return 'isUp';
        }

        if (rate < 0) {
            return 'isDown';
        }
        return '';
    };

    const getRateSymbol = (rate) => {
        return parseFloat(rate) > 0 ? '+' : '';
    };

    return {
        /** 获取涨幅的涨跌类 */
        getRateClass,
        /** 获取涨幅的涨跌标识 */
        getRateSymbol
    };
};


export const useCommonMethod = () => {
    const jumpToFund = (evt, newCode, tab = 1) => {
        const { isRender } = useFego();
        if (!newCode || !isRender.value) {
            return;
        }
        const { ftReport } = FEGORender.plugins;
        ftReport.record(evt, { $element_name: `跳转产品${newCode}` });
        window.location.href = `ftnn://quote/stockDetail/${newCode}/${tab}`;
    };

    const splitFlag = (str) => {
        if (!str) {
            return [];
        }
        return str.split('/').filter((v) => v);
    };
    return {
        /** 跳转产品详情 */
        jumpToFund,
        /** 分割亮点 */
        splitFlag
    };
};
